import { render, staticRenderFns } from "./layout.vue?vue&type=template&id=2cddcec5&scoped=true"
import script from "./layout.vue?vue&type=script&lang=ts"
export * from "./layout.vue?vue&type=script&lang=ts"
import style0 from "./layout.vue?vue&type=style&index=0&id=2cddcec5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cddcec5",
  null
  
)

export default component.exports